import React, { useState, useEffect, createContext } from 'react';

import { getI18N, i18nify } from './utils';

const INIT_I18NCONTEXT = { get: (key) => key };

export const I18NContext = createContext(INIT_I18NCONTEXT);

export const I18NProvider = ({ i18nContext, url, children }) => {
  const [messages, setMessages] = useState(i18nContext || {});

  useEffect(() => {
    if (i18nContext) {
      setMessages(i18nContext);
    } else {
      getI18N(url, setMessages);
    }
  }, [url, i18nContext]);

  if (Object.keys(messages).filter((key) => key !== 'get').length === 0) {
    return null;
  }

  return (
    <I18NContext.Provider
      value={{
        ...messages,
        get: (key, ...placeholders) => i18nify(messages, key, ...placeholders),
      }}
    >
      {children}
    </I18NContext.Provider>
  );
};

export const { Consumer: I18NConsumer } = I18NContext;
